/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NewTask/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromHelpers from './helpers.js'
import Radial from 'DesignSystem/Radial/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NewTask({
  children,
  viewPath = "/DesignSystem/EditAutomation/EventActions/Content/EventAction/Content/Content/Content/CheckRequirements/Requirement/CreateNewTask/Content/NewTask"
  
}) {
let requirementCreateTaskNewValueData = fromData.useDataValue({ viewPath,
context: 'requirement',
path: 'create_task_new',
})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath
  
})
  return (<React.Fragment
>
<Radial
  viewPath={`${viewPath}/Radial`}
 data="requirement.create_task_new"
 isSelected={requirementCreateTaskNewValueData}
 onClick={onClick}
 text="Create task when skipped"
/>
{children}
</React.Fragment>)
}